<template>
  <div class="my_enroll_detail">
    <div class="tit">
      <span>
        <router-link
          to="/personal_center/enterprise/booking_room/booking_room_record"
          class="back"
        >
          <i class="el-icon-arrow-left"></i>
        </router-link>预约看房详情
      </span>
    </div>
    <div class="body_content">
      <el-row v-if="booking_list">
        <el-col :span="5">
          <div class="detail_l">预约人：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.contact">{{ booking_list.contact }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">企业名称：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.company">{{ booking_list.company }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">租位信息：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.meeting_name">{{ booking_list.meeting_name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">园区信息：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.incubator_name">{{ booking_list.incubator_name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">面积：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.meeting_area">{{ booking_list.meeting_area }}m²</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">租金：</div>
        </el-col>
        
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.meeting_money !== ''">
            {{ booking_list.meeting_money }}
            <template v-if="booking_list.meeting_type==='MeetingTypeMeeting'">元/半小时</template>
            <template v-else-if="booking_list.meeting_type==='MeetingTypeOffice'">元/间/月</template>
            <template v-else-if="booking_list.meeting_type==='MeetingTypeStation'">元/个/月</template>
            <template v-else-if="booking_list.meeting_type==='MeetingTypeOther'">元/间/月</template>
          </div>
          <div v-else>面议</div>
        </el-col>
        <!-- <el-col :span="5">
          <div class="detail_l">管理费：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.manage_money">{{ booking_list.manage_money }}元/元</div>
          <div v-else>暂无</div>
        </el-col> -->
        <el-col :span="5">
          <div class="detail_l">联系方式：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.contact_phone">{{ booking_list.contact_phone }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">看房状态：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.status_name">{{ booking_list.status_name }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">预约时间：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.publish_date">{{ booking_list.publish_date }}</div>
          <div v-else>暂无</div>
        </el-col>
        <el-col :span="5">
          <div class="detail_l">园区意见：</div>
        </el-col>
        <el-col :span="19">
          <div class="detail_r" v-if="booking_list.examine_remark">{{ booking_list.examine_remark }}</div>
          <div v-else>暂无</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            booking_list:{} // 详情
        }
    },
    created(){
        this.getDemands()
    },
    methods:{
        // 获取详情
        getDemands(){
            this.api.getDemands({
               type:'DemandTypeConserje',
               id:this.$route.query.id
            })
            .then(res => {
                if(res.error.err_code != 0) return;
                let obj = res.obj.list[0] || {};
                if(obj.meeting_area){
                  obj.meeting_area = parseFloat(obj.meeting_area).toFixed(2);
                }
                this.booking_list = obj;
            })
        },
        // 返回
        goBack(){
            this.$router.push({
                path:'/personal_center/enterprise/booking_room/booking_room_record'
            })
        }
    }

}
</script>

<style lang="scss" scoped>
.my_enroll_detail {
    line-height: 41px;
  .tit {
    .back {
      display: inline-block;
      width: 38px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
      margin-right: 14px;
      cursor: pointer;
      vertical-align:middle;;
    }
  }
  .detail_l {
    text-align: right;
  }
}
</style>